import CardSystem from '../CardSystem';
import Renderable from '../../../Component/Renderable';
import TransformComponent from '../../../Component/Transform';
import GameObject from '../../../GameObject/GameObject';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function JokerCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    const jokerCard = system.getCardByID(taskData.cards[0]);
    const transform = jokerCard.getComponent(TransformComponent);

    system.stackContainer.addChild(jokerCard);
    jokerCard.getComponent(Renderable).visible = true;
    transform.scale.set(0.05, 0.05);
    transform.position.set(300, 0);

    const jokerAnimator = GameObject.Instantiate(Animator);
    system.animator.addChild(jokerAnimator);

    system.taskQueue.queue(
        new CardAnimationTask(
            taskData,
            system,
            'BoosterJoker',
            jokerAnimator,
            {
                jokerCard: jokerCard,
            },
            true
        )
    );
}
